import script from "./clique.vue?vue&type=script&lang=ts&setup=true"
export * from "./clique.vue?vue&type=script&lang=ts&setup=true"

import "./clique.vue?vue&type=style&index=0&id=1b46d2f6&lang=less&scoped=true"
import "./clique.vue?vue&type=style&index=1&id=1b46d2f6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b46d2f6"]])

export default __exports__